<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>
        <b-col cols="12">
            <b-row class="d-flex align-items-center justify-content-md-between">
                <b-col cols="12" md="6" class="d-md-flex">
                    <base-input
                    label="Search"
                    v-model="searchQuery"
                    v-on:input="debouncedHandler"
                    prepend-icon="fas fa-search"
                    placeholder="Search...(case-sensitive)"
                    >
                    </base-input>
                </b-col>
                <b-col cols="12" md="3" >
                    <b-button class="float-right px-3 py-2" variant="outline-secondary" disabled>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#73839C" d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z"/></svg>
                        Filters
                    </b-button>
                </b-col>
            </b-row>
        </b-col>
        <div class="table-listings">
            <el-table
                ref="multipleTable"
                :data="tableData"
                style="width: 100%"
                empty-text="No Data"
                @selection-change="selectionChange"
                v-loading="isTableLoading"
            >
                <el-table-column
                    type="selection"
                    width="55"
                ></el-table-column>

                <el-table-column label="Id"
                                min-width="90px"
                                prop="hub_pending_approval_id"
                                sortable>
                <template slot-scope="scope">
                    <template>
                        {{ scope.row.hub_pending_approval_id }}
                    </template>
                </template>
                </el-table-column>
        
                <el-table-column label="From"
                                prop="requester.name"
                                min-width="120px"
                                sortable>
                <template slot-scope="scope">
                    <div class="column_name">
                        <p class="name">{{scope.row.requester.name}}</p>
                    </div>
                </template>
                </el-table-column>

                <el-table-column label="Customer Name"
                                prop="case.prod_customer_name"
                                min-width="140px"
                                sortable>
                <template slot-scope="scope">
                    <p class="name" v-if="scope.row.requester_value[0].case">{{scope.row.requester_value[0].case.prod_customer_name}}</p>
                </template>
                </el-table-column>

                <el-table-column label="Type"
                                prop="case.prod_type"
                                min-width="120px"
                                sortable>
                <template slot-scope="scope">
                    <p v-if="scope.row.requester_value[0].case">{{scope.row.requester_value[0].case.prod_type}}</p>
                </template>
                </el-table-column>

                <el-table-column label="Detail"
                                prop="case.prod_property_mortgage"
                                min-width="180px"
                                sortable>
                <template slot-scope="scope" v-if="scope.row.requester_value[0].case">
                    <p class="break-word"><b>Project:</b> {{ scope.row.requester_value[0].case.prod_property_mortgage.prod_pm_project_name }}</p>
                    <p><b>Type:</b> {{ scope.row.requester_value[0].case.prod_property_mortgage.prod_pm_property_type }}</p>
                    <p><b>Unit No:</b> {{ scope.row.requester_value[0].case.prod_property_mortgage.prod_pm_unit_no }}</p>
                </template>
                </el-table-column>

                <el-table-column label="Amount"
                                prop="cps_develop_nett_price"
                                min-width="120px"
                                sortable>
                <template slot-scope="scope" v-if="scope.row.requester_value[0]">
                    <p>{{scope.row.requester_value[0].cps_develop_nett_price | moneyFormatter}}</p>
                </template>
                </el-table-column>

                <el-table-column label="Service Type (%)"
                                prop="cps_service_type_percentage"
                                min-width="90px"
                                sortable>
                <template slot-scope="scope">
                    <p>{{scope.row.requester_value[0].cps_service_type_percentage}}</p>
                </template>
                </el-table-column>

                <el-table-column label="Revenue Point"
                                prop="cps_balance_revenue_point"
                                min-width="120px"
                                sortable>
                <template slot-scope="scope">
                    <p>{{scope.row.requester_value[0].cps_balance_revenue_point | moneyFormatter}}</p>
                </template>
                </el-table-column>

                <el-table-column label="Acceptor"
                                prop="acceptor.name"
                                min-width="130px"
                                sortable>
                <template slot-scope="scope">
                    <p class="name" v-if="scope.row.acceptor">{{scope.row.acceptor.name }}</p>
                    <p v-else>—</p>
                    <div v-if="scope.row.is_accepted !== null">
                        <span class="badge bg-green" v-if="scope.row.is_accepted === 1">Approved</span>
                        <span class="badge bg-orange" v-if="scope.row.is_accepted === 0">Rejected</span>
                        </div>
                    <div v-else>
                        <span class="badge bg-yellow text-white">Pending</span>
                    </div>
                </template>
                </el-table-column>
        
                <el-table-column label="Reviewer"
                                prop="reviewer.name"
                                min-width="130px"
                                sortable>
                <template slot-scope="scope">
                    <p class="name" v-if="scope.row.reviewer">{{scope.row.reviewer.name }}</p>
                    <p v-else>—</p>
                    <div v-if="scope.row.is_reviewed !== null">
                        <span class="badge bg-green" v-if="scope.row.is_reviewed === 1">Approved</span>
                        <span class="badge bg-orange" v-if="scope.row.is_reviewed === 0">Rejected</span>
                        </div>
                    <div v-else>
                        <span class="badge bg-yellow text-white">Pending</span>
                    </div>
                </template>
                </el-table-column>

                <el-table-column label="Approver"
                                prop="approver.name"
                                min-width="130px"
                                sortable>
                <template slot-scope="scope">
                    <p class="name" v-if="scope.row.approver">{{scope.row.approver.name }}</p>
                    <p v-else>—</p>
                    <div v-if="scope.row.is_approved !== null">
                        <span class="badge bg-green" v-if="scope.row.is_approved === 1">Approved</span>
                        <span class="badge bg-orange" v-if="scope.row.is_approved === 0">Rejected</span>
                    </div>
                    <div v-else>
                        <span class="badge bg-yellow text-white">Pending</span>
                    </div>
                </template>
                </el-table-column>

                <el-table-column label="Content"
                                prop="content"
                                min-width="220px"
                                sortable>
                <template slot-scope="scope">
                    <b class="d-block text-break">{{ scope.row.content }}
                        <a href="#" @click.prevent="openView(scope.row)">#{{ scope.row.related_id }}</a>
                    </b>
                </template>
                </el-table-column>

                <el-table-column
                    label="Created/Updated"
                    min-width="190"
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">{{ scope.row.created_at | dateFormatString }}</p>
                        <p class="mb-0 bottom-line">{{ scope.row.updated_at | dateFormatFromNow }}</p>
                    </template>
                </el-table-column>
            </el-table>

            <PayoutDetailsModal 
                :showDirectPayoutDetails.sync="modals.showDirectPayoutDetails" 
                :currentCommsPayoutSummary="comms_payout_summaries[0]"
                :commsPayoutSummaries="comms_payout_summaries"
                :hub_pending_approval="current_view"
                @close-modal="modals.showDirectPayoutDetails=false"
                :decide_mode="decide_mode"
                :permission="permission"
                @refetch-comms-payout-details="getHubPendingApprovalList"
            />
        </div>
    </b-card>
</template>
<script>
import { Table, TableColumn, Select, Option, Tooltip } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { axios, services, getHeader,debounce } from '@/assets/js/httpImports.js'
import { EventBus } from '../../../main'
import PayoutDetailsModal from "@/views/Commission/Hub/HubProfile/CenterProfileDetails/PayoutDetailsModalV2";
import { useAuthStore } from '@/stores/authStore'
import { mapState, mapActions } from 'pinia'
import { MANAGER_ROLE_IDS } from '@/assets/js/roles.js' 

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        PayoutDetailsModal,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [Tooltip.name]: Tooltip,
    },
    data() {
        return {
            isTableLoading: true,
            propsToSearch:['requester.name', 'content','reviewer.name', 'acceptor.name', 'approver.name'],
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            tableData: [],
            manager_role_ids: MANAGER_ROLE_IDS,
            modals:{
                showDirectPayoutDetails: false,
            },
            current_view: [],
            comms_payout_summaries: [],
            decide_mode: false,
            permission: {
                acceptor: false,
                reviewer: false,
                approver: false,
                admin: false,
            }
        }
    },
    computed: {
        ...mapState(useAuthStore,['auth_user']),
    },
    created() {
        this.getHubPendingApprovalList();
    },
    mounted() {
        this.debouncedHandler = debounce(() => {
        }, 500);
    },
    methods: {
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
        getHubPendingApprovalList() {
            this.isTableLoading = true
            axios.get(services.hub + 'hub_comms/hub_pending_approval', { headers: getHeader() })
            .then(response => {
                this.isTableLoading = false
                this.tableData = response.data.data;
            })
            .catch ( error => {
                this.isTableLoading = false
                this.errorFunction(error, "Showing Hub Approval Listing failed: " + error.response.data.message) 
            });
        },
        openView(row) {
            this.modals.showDirectPayoutDetails = true;
            this.current_view = row;
            this.comms_payout_summaries = row.requester_value;
            this.getPermissionSetting();
            // overwrite all button
            // this.decide_mode = false;
        },
        getPermissionSetting() {
            const hub_pending_approval = this.current_view;
            
            if(hub_pending_approval.is_accepted == 0 || hub_pending_approval.is_reviewed == 0 || hub_pending_approval.is_approved == 0 || hub_pending_approval.is_approved != null)
            {
                this.decide_mode = false;
            }
            else if(hub_pending_approval.is_accepted === null || hub_pending_approval.is_reviewed === null || hub_pending_approval.is_approved === null)
            {

                this.decide_mode = true;
                this.checkIsAdmin();
                if(!this.permission.admin)
                {
                    this.checkIsAcceptor();
                    this.checkIsReviewer();
                    this.checkIsApprover();
                }
            }
        },
        checkIsAcceptor() {
            if(this.auth_user.id == this.current_view.requester_value[0].hub.hub_manager.id)
            {
                this.permission.acceptor = true;
            }
            else
            {
                this.permission.acceptor = false;
            }
        },
        checkIsReviewer() {
            axios.get(services.hub + 'hub_comms/hub_pending_approval.check_is_reviewer/COMMS_PAYOUT_SUMMARY', { headers: getHeader() })
            .then(res => {
                if(res.data == 1)
                {
                    this.permission.reviewer = true;
                }
                else
                {
                    this.permission.reviewer = false;
                }
            })
            .catch ( error => {
                this.errorFunction(error, "Checking is reviewer function failed: " + error.response.data.message) 
            });
        },
        checkIsApprover() {
            axios.get(services.hub + 'hub_comms/hub_pending_approval.check_is_approver/COMMS_PAYOUT_SUMMARY', { headers: getHeader() })
            .then(res => {
                if(res.data == 1)
                {
                    this.permission.approver = true;
                }
                else
                {
                    this.permission.approver = false;
                }
            })
            .catch ( error => {
                this.errorFunction(error, "Checking is approver function failed: " + error.response.data.message) 
            });
        },
        checkIsAdmin() {
            if(_gHlp.checkRoleType( ['admin', 'corporate']))
            {
                this.permission.admin = true;
            }
            else
            {
                this.permission.admin = false;
            }
        },
    }
}
</script>